export const getStore = store => (store.customer ? store.customer : {});
export const isLoaded = store => {
  let customer = getStore(store);
  return customer.isLoaded != null && customer.isLoaded;
};
export const getCustomer = store => getStore(store).customer;
